export const request_struct = [
    {key: 'download_type', name: 'download-type'},
    {key: 'request_type', name: 'request-type'},
    {key: 'start_date', name: 'start-date'},
    {key: 'start_time', name: 'start-time'},
    {key: 'end_date', name: 'end-date'},
    {key: 'end_time', name: 'end-time'},
];